(function () {
  'use strict';

  function loadMenuImages() {
    document.querySelectorAll('img[data-vatpan-menu-src]').forEach(function (img) {
      var src = img.getAttribute('data-vatpan-menu-src');
      if (!src || img.getAttribute('src') === src) return;
      img.src = src;
    });
  }

  var nav = document.querySelector('.site-header');
  if (nav) {
    nav.addEventListener('pointerenter', loadMenuImages, { once: true });
    nav.addEventListener('pointermove', loadMenuImages, { once: true });
    nav.addEventListener('focusin', loadMenuImages, { once: true });
    nav.addEventListener('touchstart', loadMenuImages, { once: true, passive: true });
  }

  document.addEventListener('click', function (event) {
    if (!window.matchMedia('(min-width: 1024px)').matches) return;

    var summary = event.target.closest(
      '.navmenu-meganav-sidenav__item > details > summary[data-href]'
    );
    if (!summary) return;

    var href = summary.getAttribute('data-href');
    if (!href || href === '#') return;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(href);
  }, true);
})();
